import Vue from 'vue'
import Router from 'vue-router'

//页面
import Index from '@/pages/index/index'
import privacyPolicy from '@/pages/privacy-policy/index'
import termsAndConditions from '@/pages/terms-and-conditions/index'
import About from '@/pages/about/index'
import Service from '@/pages/service/index'
import News from '@/pages/news/index'
import Contact from '@/pages/contact/index'
import SignIn from '@/pages/sign_in/index'
import EditEmail from '@/pages/edit_email/index'
import Information from '@/pages/information/index'
import WatchList from '@/pages/watch_list/index'
import Device from '@/pages/device/index'

Vue.use(Router);

export default new Router({
	mode: 'history',
	scrollBehavior(to, from, savePosition) {
		if(savePosition){
			return savePosition
		}else{
			return { x: 0, y: 0 }
		}
	},
	routes: [
		{
		  path: '*',
		  redirect: '/'
		},{
			path: '/',
			name: 'Index',  //主页
			component: Index,
			meta: {
				requireAuth: true,
				title: 'Home'
			}
		},{
			path: '/privacy-policy',
			name: 'privacyPolicy',
			component: privacyPolicy,
			meta: {
				requireAuth: true,
				title: 'Privacy Policy'
			}
		},{
			path: '/terms-and-conditions',
			name: 'termsAndConditions',
			component: termsAndConditions,
			meta: {
				requireAuth: true,
				title: 'Terms and Conditions'
			}
		},{
			path: '/about',
			name: 'About',  //About
			component: About,
			meta: {
				requireAuth: true,
				title: 'About'
			}
		}
		// ,{
		// 	path: '/services',
		// 	name: 'Service',  //Service
		// 	component: Service,
		// 	meta: {
		// 		requireAuth: true,
		// 		title: 'Services'
		// 	}
		// }
		,{
			path: '/news',
			name: 'News',  //News
			component: News,
			meta: {
				requireAuth: true,
				title: 'News & Events'
			}
		},{
			path: '/news/:newsId',
			name: 'newsInfo',  //文章详情
			component: resolve => require(['@/pages/news/info'], resolve), 
			meta: {
				requireAuth: true,
				title: 'News & Events'
			}
		},{
			path: '/contact',
			name: 'Contact',  //Contact
			component: Contact,
			meta: {
				requireAuth: true,
				title: 'Contact Us'
			}
		},{
			path: '/sign-in',
			name: 'SignIn',  //Sign
			component: SignIn,
			meta: {
				requireAuth: true,
				title: 'Sign in'
			}
		},{
			path: '/edit-email',
			name: 'EditEmail',  //编辑邮箱
			component: EditEmail,
			meta: {
				requireAuth: true,
				title: 'Edit email'
			}
		},{
			path: '/information',
			name: 'Information',  //Information
			component: Information,
			meta: {
				requireAuth: true,
				title: 'Information'
			}
		},{
			path: '/watch-list',
			name: 'WatchList',  //WatchList
			component: WatchList,
			meta: {
				requireAuth: true,
				title: 'Product Watch List'
			}
		},{
			path: '/products',
			name: 'Products',  //产品中心
			component: resolve => require(['@/pages/products/index'], resolve), 
			meta: {
				requireAuth: true,
				title: 'Products'
			}
		},{
			path: '/products/:productId',
			name: 'ProductInfo',  //产品详情
			component: resolve => require(['@/pages/products/info'], resolve), 
			meta: {
				requireAuth: true,
				title: 'Products'
			}
		},
		// {
		// 	path: '/devices',
		// 	name: 'Device',  //Device
		// 	component: Device,
		// 	meta: {
		// 		requireAuth: true,
		// 		title: 'Devices'
		// 	}
		// },{
		// 	path: '/devices/:deviceId',
		// 	name: 'DeviceInfo',  //设备详情
		// 	component: resolve => require(['@/pages/device/info'], resolve), 
		// 	meta: {
		// 		requireAuth: true,
		// 		title: 'Devices'
		// 	}
		// }
	]
})